import { useState, useEffect } from 'react';
import { useApiClient } from '../api/client';

interface AppConfig {
  title: string;
  max_input_chars: number;
  max_turns_per_campaign: number;
}

export function useAppConfig() {
  const api = useApiClient();
  const [config, setConfig] = useState<AppConfig | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    let cancelled = false;
    api.get('/config')
      .then(data => {
        if (!cancelled) {
          setConfig(data as AppConfig);
          setError(null);
        }
      })
      .catch(err => {
        if (!cancelled) {
          setError(err instanceof Error ? err.message : 'Unknown error');
          setConfig(null);
        }
      })
      .finally(() => { if (!cancelled) setLoading(false); });
    return () => { cancelled = true; };
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  return { config, loading, error };
}
